import { defineCustomElement } from "vue";
import App from "./App.vue";

customElements.define("avp-3dws-deck", defineCustomElement(App));
